/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { Modal } from 'antd-mobile'
import { observer } from 'mobx-react'
import { globalStore } from '@store/index'
// css
import { ModalBg } from '@styles/base.style'
import { Button } from '@styles/button.style'
import { AdvDialogBtnWrap, AdvDialogStyle } from '@styles/modal'
import { GuideImgWrap, GuideWrap } from '@views/Popup/GuidePopup/index.style'
import BettingCancelCharacter from '@assets/images/bg/character/betting-cancel.png'

const BetCancelFailPopup: React.FC = props => {
  const { visibleBetCancelFailPopup } = globalStore

  const onCloseModal = async () => {
    globalStore.setVisibleBetCancelFailPopup(false)
  }

  return (
    <Modal
      transparent
      visible={visibleBetCancelFailPopup}
      maskClosable={false}
      onClose={onCloseModal}
      className="adv-new-dialog box-type big-size character-popup"
      wrapClassName="guide-notice-popup"
      css={AdvDialogStyle}
    >
      {/* 캐릭터 영역 */}
      <GuideImgWrap>
        <div className="guide-circle">
          <img src={BettingCancelCharacter} alt="캐릭터" className="guide-character"/>
        </div>
        <p className="guide-txt big">
          베팅 후 <span className="point-color--orange--modal">10분</span>까지만 취소가 가능합니다.
        </p>
      </GuideImgWrap>

      <GuideWrap>
        <div className="guide-box small">
          단, 경기시작 5분 전부터는 취소 불가합니다.
        </div>
      </GuideWrap>

      <AdvDialogBtnWrap className="adv-dialog-btn-wrap">
        <Button secondary onClick={onCloseModal} className="single-btn">
          확인
        </Button>
      </AdvDialogBtnWrap>

      <ModalBg onClick={onCloseModal}/>
    </Modal>
  )
}

export default observer(BetCancelFailPopup)
